<script>
import { defineComponent } from '@vue/composition-api'
import { WarningServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
import useTable from '@/hooks/useTable'
import useModal from '@/hooks/useModal'
import { dayjsFormat } from '@/utils'
import FileForm from './FileForm'

const wsp = new WarningServiceProxy()

export default defineComponent({
  components: {
    FileForm,
  },
  setup(_, { root }) {
    const { tableAttrs, read, currentRecord } = useTable(
      {
        columns: [
          { title: '操作', scopedSlots: { customRender: 'action' }, i18n: 'actions' },
          { title: '设备编码', dataIndex: 'deviceCode', i18n: 'page_plan_maintenance_equipment_coding' },
          { title: '设备名称', dataIndex: 'deviceName', i18n: 'page_plan_maintenance_equipment_name' },
          { title: '设备类型', dataIndex: 'deviceTypeName', i18n: 'page_plan_maintenance_equipment_type' },
          { title: '检验项目', dataIndex: 'checkProjectName', i18n: 'page_tpm_check_record_project' },
          {
            title: '点检时间',
            dataIndex: 'checkTime',
            customRender: time => dayjsFormat(time),
            i18n: 'page_tpm_check_record_time'
          },
        ],
        rowSelection: null,
      },
      { read: wsp.getPageCheckRecordCurrent.bind(wsp) },
      undefined,
      (current, pageSize) => read(current, pageSize)
    )

    const {
      modalAttrs: fileModalAttrs,
      modalEvents: fileModalEvents,
      open: openFileModal,
      close: closeFileModal,
    } = useModal({
      title: root.$t('accessory' || '附件'),
    })

    // init
    read(tableAttrs.pagination.current, tableAttrs.pagination.pageSize)

    return {
      tableAttrs,
      currentRecord,

      fileModalAttrs,
      fileModalEvents,
      openFileModal,
      closeFileModal,
    }
  },
})
</script>

<template>
  <div>
    <ml-table v-bind="tableAttrs">
      <template #action>
        <a @click="openFileModal">{{ $t('page_tpm_check_watch_file' || '查看附件') }}</a>
      </template>
    </ml-table>

    <a-modal v-bind="fileModalAttrs" v-on="fileModalEvents">
      <FileForm :data="currentRecord" />
      <template #footer>
        <a-button @click="closeFileModal">{{ $t('cancel' || '取消') }}</a-button>
      </template>
    </a-modal>
  </div>
</template>
